/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Box } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SearchField } from '@opengeoweb/shared';
import type { DataExplorerTypes } from '../../store';
import { dataExplorerSelectors, dataExplorerActions } from '../../store';
import { useDataExplorerTranslation } from '../../utils/i18n';

export const DataExplorerSearchConnect: React.FC = () => {
  const { t } = useDataExplorerTranslation();
  const dispatch = useDispatch();
  const searchFilter = useSelector(
    (store: DataExplorerTypes.DataExplorerModuleState) =>
      dataExplorerSelectors.getSearchFilter(store),
  );

  const setSearchFilter = (filterText: string): void => {
    dispatch(dataExplorerActions.setSearchFilter({ filterText }));
  };

  return (
    <Box
      data-testid="dataexplorerSearchBox"
      sx={{ padding: '8px 24px 8px 24px' }}
    >
      <SearchField
        label={t('dataexplorer-search-datasets')}
        onOpenServicePopup={() => {}}
        searchFilter={searchFilter}
        setSearchFilter={setSearchFilter}
      />
    </Box>
  );
};
